import './index.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SwipeArrowImage from '../../../assets/images/swipe-arrow.svg';
import CrownWhiteImage from '../../../assets/images/offers/crown-white.svg';

let initialX = null;
let initialY = null;

class OffersSwipeCrown extends Component {
  componentDidMount() {
    const myElement =
      document && document.getElementsByClassName('swipe-crown')[0];
    if (myElement && window.innerWidth < 768) {
      myElement.addEventListener('touchstart', this.handleTouchStart, false);
      myElement.addEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  componentWillUnmount() {
    const myElement =
      document && document.getElementsByClassName('modal_wrapper')[0];
    if (myElement && window.innerWidth < 768) {
      myElement.removeEventListener('touchstart', this.handleTouchStart, false);
      myElement.removeEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  handleTouchStart = e => {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  handleTouchMove = e => {
    if (initialX === null) return;
    if (initialY === null) return;

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;

    const diffX = initialX - currentX;
    const diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      const { onClick } = this;
      if (diffX > 0) {
        // swiped left
      } else {
        onClick(true); // swiped right
      }
    }

    initialX = null;
    initialY = null;
    e.preventDefault();
  };

  onClick = isSwipedForMob => {
    const { innerWidth } = window;
    const { onClick } = this.props;

    if (innerWidth < 768 && isSwipedForMob) {
      onClick();
    } else if (innerWidth > 768) {
      onClick();
    }
  };

  render() {
    const { onClick } = this;
    const { value, theme } = this.props;

    return (
      <div
        className={`swipe-crown ${theme}`}
        role="presentation"
        onClick={() => onClick()}
      >
        <img
          className="swipe-crown__image"
          src={SwipeArrowImage}
          alt="swipe-arrow"
        /> 
        <p className="u_display_only_mob">
          swipe to burn
          <img
            src={CrownWhiteImage}
            alt="crown"
            className="swipe-crown__crown-img"
          />
          {value}
        </p>
        <p className="swipe-crown__des">
          burn
          <img
            src={CrownWhiteImage}
            alt="crown"
            className="swipe-crown__crown-img"
          />
          {value}
        </p>
      </div>
    );
  }
}

export default OffersSwipeCrown;

OffersSwipeCrown.propTypes = {
  value: PropTypes.string
};

OffersSwipeCrown.defaultProps = {
  value: ''
};
